import React from 'react'
import PropTypes from 'prop-types'
import {
  Circle as FeatherCircle,
  CheckCircle as FeatherCheckCircle,
} from 'react-feather'

const CheckCircle = ({ isChecked, size, ...rest }) => {
  if (isChecked === true) {
    return (
      <FeatherCheckCircle
        size={size}
        stroke="hsl(120, 100%, 25%)"
        strokeWidth={3}
        {...rest}
      />
    )
  }
  return <FeatherCircle size={size} stroke="hsl(0,0%,55%)" {...rest} />
}

CheckCircle.defaultProps = {
  isChecked: false,
  size: 16,
}

CheckCircle.propTypes = {
  isChecked: PropTypes.bool,
  size: PropTypes.number,
}

export default CheckCircle
